import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ShieldCheck, Star } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-12 pb-20 px-4 overflow-hidden bg-[#FFF8E7]" data-id="element-35">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-20 pointer-events-none" data-id="element-36">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-[#D4A017] rounded-full blur-3xl" data-id="element-37"></div>
        <div className="absolute top-1/2 -left-24 w-64 h-64 bg-[#C67B5C] rounded-full blur-3xl" data-id="element-38"></div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-39">
        <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-40">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} className="flex-1 text-center lg:text-left" data-id="element-41">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#FFFDF5] border border-[#D4A017] rounded-full text-[#5C3D2E] font-medium mb-6 shadow-sm" data-id="element-42">
              <Star className="w-5 h-5 text-[#D4A017] fill-current" data-id="element-43" />
              <span data-id="element-44">Para mujeres 65+ que quieren despertar sin dolor</span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-[#5C3D2E] leading-tight" data-id="element-45">
              Desinflama tu cuerpo mientras duermes por menos de lo que cuesta
              un almuerzo.
            </h1>

            <p className="text-xl md:text-2xl mb-8 text-[#5C3D2E] opacity-90" data-id="element-46">
              <strong data-id="element-47">Cenas en 1 Olla: El Método Anti-Inflamatorio.</strong>
              <br data-id="element-48" />
              Recupera tu agilidad y alivia tus articulaciones sin pasar horas
              fregando platos.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start" data-id="element-49">
              <Button onClick={scrollToPricing} size="xl" className="w-full sm:w-auto shadow-xl shadow-[#D4A017]/20" data-id="element-50">
                ¡Sí, Quiero Desinflamar Mi Cuerpo!
              </Button>
            </div>

            <div className="mt-6 flex items-center justify-center lg:justify-start gap-2 text-[#5B7A3A] font-medium" data-id="element-51">
              <ShieldCheck className="w-6 h-6" data-id="element-52" />
              <span data-id="element-53">Garantía de 7 días. Pago 100% seguro.</span>
            </div>
          </motion.div>

          {/* Image/Mockup */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="flex-1 w-full max-w-md lg:max-w-full relative" data-id="element-54">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white transform rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-55">
              <img src="https://cdn.magicpatterns.com/uploads/fapzPButvVY2WpFB96L7Xs/CENAS_EN_1_OLLAS.png" alt="Portada del libro Cenas en 1 Olla" className="w-full h-auto object-cover" data-id="element-56" />

              {/* Price Badge */}
              <div className="absolute -top-4 -right-4 bg-[#C67B5C] text-white w-24 h-24 rounded-full flex flex-col items-center justify-center shadow-lg transform rotate-12 border-4 border-white" data-id="element-57">
                <span className="text-sm font-bold uppercase leading-none" data-id="element-58">
                  Solo
                </span>
                <span className="text-2xl font-black leading-none" data-id="element-59">$9.99</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}